/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { markSkipOnCompleteIfOnSuccessIsSet, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { AddAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import {
    AddAccount,
    AddAccountParameter,
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
//  <xng-change MIDPT-213:  changed service import to take the costume service>
import { xngaddAccount as addAccountApi } from "@eisinc/App/Services/AccountService";
//  <xng-change>
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

interface XAddAccountParameter extends  Omit<AddAccountParameter,"onSuccess"> {
    onSuccess?: (result: any) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    XAddAccountParameter,
    AddAccountApiParameter,
    ServiceResult<AccountModel>
>;

export const xAddAccount: HandlerType = async props => {
    stopWatchingForOtherTabSessionChange();
    props.apiResult = await addAccountApi(props.apiParameter);
    watchForOtherTabSessionChange();
};

export const xExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};

replaceInChain(chain, ExecuteOnSuccessCallback, xExecuteOnSuccessCallback);

replaceInChain(chain, AddAccount, xAddAccount);
